import(/* webpackMode: "eager" */ "/vercel/path0/src/app/[lang]/products/page.tsx");
